import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import NotificationsAlert from "../../services/NotificationsAlert";
import { ClienteContext } from "../../services/ClienteContext";
import Conect from "../../../Api/Conect";

import "./styles.css";
import Logo from '../../assets/Logo 300x300N.png'


const UserLogin = () => {

    const history = useNavigate();
    const { register, handleSubmit, } = useForm();
    const cliente = useContext(ClienteContext);
    const [login, setLogin] = useState()
    const [password, setPassword] = useState()
    // eslint-disable-next-line
    const [saveDataUser, setSaveDataUser] = useState(false)


    useEffect(() => {
        verifyToken()
        // eslint-disable-next-line
    }, [])

    const verifyToken = async () => {

        let token = localStorage.getItem("worldofgus_token")

        if (token !== null) {
            history("/home")
        }
    };

    const onSubmit = async (data) => {
        const savedLogin = localStorage.getItem("worldofgus_savedLogin");
        const savedPassword = localStorage.getItem("worldofgus_savedPassword");

        const usuario = await Conect.post("/api/auth/login", {
            login: !data.login ? savedLogin : data.login,
            password: !data.password ? savedPassword : data.password
        })

        if (usuario.data.erro === true) {
            if (usuario.data.aut === true) {
                NotificationsAlert("danger", "Atenção", usuario.data.msg)
            } else {
                NotificationsAlert("warning", "Atenção", usuario.data.msg)
            }
        }
        else if (usuario.data.erro === false) {
            localStorage.setItem("worldofgus_id", usuario.data.data.id)
            localStorage.setItem("worldofgus_firstName", usuario.data.data.firstName)
            localStorage.setItem("worldofgus_lastName", usuario.data.data.lastName)
            localStorage.setItem("worldofgus_token", usuario.data.data.token)

            cliente.setDados({
                user_id: usuario.data.data.id,
                name: `${usuario.data.data.firstName} ${usuario.data.data.lastName}`,
                token: usuario.data.data.token,
            });
            let message = `Olá! ${usuario.data.data.firstName}!`
            NotificationsAlert("default", message, "")
            // Salva ou remove os dados de login e senha
            if (saveDataUser) {
                localStorage.setItem("worldofgus_savedLogin", data.login === '' ? savedLogin : data.login);
                localStorage.setItem("worldofgus_savedPassword", data.password === '' ? savedPassword : data.password);
                localStorage.setItem("worldofgus_savedSavad", saveDataUser);
            } else {
                localStorage.removeItem("worldofgus_savedLogin");
                localStorage.removeItem("worldofgus_savedPassword");
                localStorage.removeItem("worldofgus_savedSavad");
            }
            history("/home");
        }
    };

    return (
        <div style={{ width: '100vw', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="container-login">
                <div className="wrap-login">
                    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                        <span className="login-form-title"> World Of Gus Mine Server </span>

                        <span className="login-form-title">
                            <img src={Logo} alt="Sakamotto Server Logo" />
                        </span>

                        <div className="wrap-input">
                            <input
                                className={login !== "" ? "has-val input" : "input"}
                                type="login"
                                value={login}
                                onChange={(e) => setLogin(((e.target.value).trim()).toLowerCase())}
                                {...register("login")}
                            />
                            <span className="focus-input" data-placeholder="Login"></span>
                        </div>

                        <div className="wrap-input">
                            <input
                                className={password !== "" ? "has-val input" : "input"}
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                {...register("password")}
                            />
                            <span className="focus-input" data-placeholder="Password"></span>
                        </div>
                        {/* <div className="div-savelogin">
                            <span>Salvar login? </span>
                            <input
                                type="checkbox"
                                checked={saveDataUser}
                                onChange={() => setSaveDataUser(!saveDataUser)}
                            />
                        </div> */}
                        <div className="container-login-form-btn">
                            <button className="login-form-btn">Login</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )

}

export default UserLogin;
